import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useMediaQuery } from 'react-responsive'
import "./book.styles.css"

export default function Book() {
  const isMobile = useMediaQuery({ query: '(max-width: 450px)' })
  return (
    <div className="book-container" id="book">
      <Container>
        <div className="book-box">
          {isMobile ? (
            <Row className="book-heading">
              <Col xs={12} md={6} style={{ display: "flex" }}>Don’t Delay Care For You and Those You Love.</Col>
              <Col xs={12} md={6}></Col>
            </Row>) : (<div className="book-heading">
              <div xs={12} md={6} style={{ display: "flex", width: "80%" }}>Don’t Delay Care For You and Those You Love.</div>
            </div>)
          }
          <Row>
            <Col className="book-button-container">
              <button className="book-button" onClick={() => { window.open("https://api.whatsapp.com/send/?phone=918707699762&text=9999202000%20press%20send%20to%20book%20appointment%20with%20Dr.%20Aashima%20%F0%9F%91%89") }}>Book an Appointment</button>
            </Col>
          </Row>
        </div >
      </Container >
    </div >
  )
}
